module.exports = __webpack_public_path__ + "static/media/switch.34af508a.svg";